import { createSlice } from '@reduxjs/toolkit';

interface AlertState {
  featureDisabled: boolean;
}

const initialState: AlertState = {
  featureDisabled: true,
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {},
});

export default alertSlice.reducer;
